import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import informationAPI from '../../api/informationAPI';
import getAsyncErrorMessage from '../../utils/getAsyncErrorMessage';
import { GENERAL_ERROR_MESSAGE } from '../../constants';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../store';
import type { RejectedWithValueAction } from '../../types/common';
import type { TradingCompanyInformationState } from '../../types/tradingCompanyInformation';

export const initialState: TradingCompanyInformationState = {
  isLoading: false,
  hasError: false,
  serverMessage: undefined,
  tradingCompanyInformations: undefined,
  displayTradingCompanyInformations: true,
};

const slice = createSlice({
  name: 'TradingCompanyInformation',
  initialState,
  reducers: {
    resetServerMessage(state: TradingCompanyInformationState) {
      state.isLoading = false;
      state.serverMessage = '';
      state.hasError = false;
    },

    setServerMessage(state: TradingCompanyInformationState, action: PayloadAction<string>): void {
      state.isLoading = false;
      state.serverMessage = action.payload;
    },

    hideTradingCompanyInformation(state: TradingCompanyInformationState): void {
      state.displayTradingCompanyInformations = false;
    },
  },

  extraReducers: (builder) => {
    builder
      // Get TradingCompanyInformation
      // ----------------------------------------
      .addCase(getTradingCompanyInformations.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTradingCompanyInformations.fulfilled, (state, action) => {
        // console.log('reduce information');
        state.isLoading = false;
        state.tradingCompanyInformations = action.payload;
      })
      .addCase(getTradingCompanyInformations.rejected, (state, action) => {
        // actionはwithValueでpayloadがある
        const rejectedWithValueAction = action as RejectedWithValueAction<undefined, string>;
        const message: string = rejectedWithValueAction.payload !== '' ? rejectedWithValueAction.payload : GENERAL_ERROR_MESSAGE;
        state.isLoading = false;
        state.hasError = true;
        state.serverMessage = message;
        state.tradingCompanyInformations = state.tradingCompanyInformations === undefined ? [] : state.tradingCompanyInformations;
      });
  },
});

export const { reducer, actions } = slice;

export const resetServerMessage =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(slice.actions.resetServerMessage());
  };

export const hideTradingCompanyInformation =
  (): AppThunk =>
  (dispatch): void => {
    dispatch(slice.actions.hideTradingCompanyInformation());
  };

export const getTradingCompanyInformations = createAsyncThunk('TradingCompanyInformation/getTradingCompanyInformations', async (_, thunkAPI) => {
  try {
    const response = await informationAPI.getTradingCompanyInformations();
    return response.data;
  } catch (err) {
    const message: string = getAsyncErrorMessage(err);
    return thunkAPI.rejectWithValue(message);
  }
});

export default slice;
